export default __webpack_public_path__ + "17804ac16cf47d5319b6afcd778619b4.png";